var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EA3636"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2588 34.465L23.6149 32.5063C24.1804 32.0381 24.5102 31.3236 24.5102 30.5722V27.3692C28.068 26.162 31.9202 26.1497 35.4898 27.3692V30.5845C35.4898 31.336 35.8196 32.0505 36.3851 32.5186L38.7295 34.465C39.6719 35.2411 41.0149 35.1672 41.8631 34.2802L43.3004 32.7773C44.2428 31.7918 44.2428 30.1533 43.2415 29.2294C35.6901 22.2569 24.3099 22.2569 16.7585 29.2294C15.7572 30.1533 15.7572 31.7918 16.6996 32.7773L18.1369 34.2802C18.9733 35.1672 20.3163 35.2411 21.2588 34.465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/EndCall.e395682fa171191dffd5ad22fbf755f9.svg";
export { ForwardRef as ReactComponent };